var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueSignaturePad',{ref:"signaturePad",attrs:{"id":"signature","width":"100%","height":"300px","options":{onEnd: _vm.onEnd}}})
}
var staticRenderFns = []

export { render, staticRenderFns }